import React, { useState, useEffect } from 'react';
import logo from '../assets/vilecpalogo.png';
import './Header.css';

const Header = () => {
 const [isScrolled, setIsScrolled] = useState(false);
 const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

 useEffect(() => {
  const handleScroll = () => {
   setIsScrolled(window.scrollY > 50);
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
 }, []);

 const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
   element.scrollIntoView({ behavior: 'smooth' });
  }
  setIsMobileMenuOpen(false);
 };

 return (
  <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
   <div className='container'>
    <div className='header-content'>
     <div className='logo animate-fade-in-left'>
        <div className ='logo'>
            <img src={logo} alt='Vi Le CPA Logo'/>
            <h2>Vi Le CPA, PLLC</h2>
        </div>
    </div>

     <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
      <a
       href='#home'
       onClick={() => scrollToSection('home')}
       className='nav-text'
      >
       Home
      </a>
      <a
       href='#services'
       onClick={() => scrollToSection('services')}
       className='nav-text'
      >
       Services
      </a>
      <a
       href='#about'
       onClick={() => scrollToSection('about')}
       className='nav-text'
      >
       About
      </a>
      <a
       href='#contact'
       onClick={() => scrollToSection('contact')}
       className='nav-text'
      >
       Contact
      </a>
      <a
       href='https://vilecpa.clientportal.com'
       target='_blank'
       rel='noopener noreferrer'
       className='btn btn-primary'
      >
       Log In
      </a>
     </nav>

     <button
      className='mobile-menu-toggle'
      onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
     >
      <span></span>
      <span></span>
      <span></span>
     </button>
    </div>
   </div>
  </header>
 );
};

export default Header;
